<ng-container *ngIf="loaded && actions && actions[selectedActionIndex]">
  <section class="guide-root">
    <header class="guide-header">
      <div class="guide-header-left">
        <h1 class="guide-title">{{ actions[selectedActionIndex].action_name }}</h1>
        <div class="guide-step">Etapa {{ selectedActionIndex + 1 }} de {{ actions.length }}</div>
      </div>

      <div class="guide-header-right">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            [style.width.%]="((selectedActionIndex + 1) / actions.length) * 100"
            [attr.aria-valuemin]="0"
            [attr.aria-valuemax]="100"
            [attr.aria-valuenow]="((selectedActionIndex + 1) / actions.length) * 100"
          ></div>
        </div>

        <div class="steps">
          <button
            type="button"
            class="step-dot"
            *ngFor="let a of actions; let i = index"
            [class.active]="i === selectedActionIndex"
            (click)="selectedActionIndex = i"
            [attr.aria-label]="'Ir para etapa ' + (i + 1)"
          ></button>
        </div>
      </div>
    </header>

    <div class="guide-content">
      <ng-container [ngSwitch]="actions[selectedActionIndex].action_type">
        <ng-container *ngSwitchCase="'QUESTIONNAIRE'">
          <app-questionnaire-answer
            [claimId]="claimId!"
            [questionnaireId]="actions[selectedActionIndex].questionnaire_id!"
            (completed)="onComplete()"
          ></app-questionnaire-answer>
        </ng-container>
        <ng-container *ngSwitchCase="'KYC'">
          <app-kyc
            [action]="actions[selectedActionIndex]"
            (completed)="onComplete()"
          ></app-kyc>
        </ng-container>
        <ng-container *ngSwitchCase="'SIGNATURE'">
          <app-eletronic-signature-modal
            [contractId]="actions[selectedActionIndex].contract_id!"
            [claimId]="actions[selectedActionIndex].claim_id!"
            [componentView]="true"
            (onComplete)="onComplete()"
          ></app-eletronic-signature-modal>
        </ng-container>
        <ng-container *ngSwitchDefault> </ng-container>
      </ng-container>
    </div>
  </section>
</ng-container>
